import React, { useState } from 'react'
import BusinessStyles from './AddProduct.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import axios from 'axios';

import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'

//   notification section End


const AddProduct = () => {
    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const dispatch =  useDispatch()
    const location = useLocation()
    const data = location.state
    console.log(data)

    const navigate = useNavigate()

    

    const inputRef = React.useRef();

    const [file, setFile] = useState(null)
    const [businessData, setBusinessData] = useState({
        portalName: '',
        portalDescription: '',
        portalLink: '',
    })
    const [source, setSource] = React.useState();
    const [fileName, setFileName] = React.useState('');
    const [imageSelect, setImageSelect] = useState(false)

    const handleInputChange = (event) => {
        const {name, value} = event.target
        setBusinessData({ ...businessData, [name]: value })
    }


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileName(file.name)
        const url = URL.createObjectURL(file);
        setSource(url);
        setImageSelect(true)
        setFile(file)
    };

    const handleChoose = (event) => {
        inputRef.current.click();
    };

    const discardImage = (event) => {
        setSource(null)
        setFileName('')
        setFile(null)
        inputRef.current.value = ""
        setImageSelect(false)
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        const formDataObj = new FormData()
        formDataObj.append("file", file)
        formDataObj.append("portalName", businessData.portalName)
        formDataObj.append("portalDescription", businessData.portalDescription)
        formDataObj.append("portalLink", businessData.portalLink)

        try{
            const imageResponse = await axios.post(
                `${process.env.REACT_APP_STEELADMIN}/mainportal/uploadPortalImage`,
                formDataObj,
                {
                    headers: {
                        "Content-Type": "image/jpeg"
                    }
                }
            )
            // console.log(imageResponse)

            const businessResponse = await axios.post(
                `${process.env.REACT_APP_STEELADMIN}/mainportal/addPortalDetails/${imageResponse.data.imgId}`,
                businessData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
                // this is the snipte for the notification
           dispatch(fetchNotifications())

           dispatch(setNotificationCount({
            count:count+1,
           }))
            // console.log('Product Added.')
            // console.log(businessResponse)
            alert('Product Added');

            discardImage()
            

        } catch (error) {
            console.error(error)
        }
        
        navigate('/productpage')
    }

    return (
        <div className={BusinessStyles.businessMain}>
            <div className={BusinessStyles.businessContent}>
                <form action="" className={BusinessStyles.businessForm} onSubmit={handleSubmit} encType='multipart/form-data'>
                    <label className={BusinessStyles.businessFormLabel}>Portal Name</label>
                    <input className={BusinessStyles.businessFormText} type="text" value={businessData.portalName} name='portalName' onChange={handleInputChange} />
                    <label className={BusinessStyles.businessFormLabel}>Description</label>
                    <textarea className={BusinessStyles.businessFormDesc} value={businessData.portalDescription} name='portalDescription' onChange={handleInputChange} />
                    <label className={BusinessStyles.businessFormLabel}>URL Link</label>
                    <input className={BusinessStyles.businessFormText} type="text" value={businessData.portalLink} name='portalLink' onChange={handleInputChange} />
                    <label className={BusinessStyles.businessFormLabel}>Upload</label>
                    <div className={BusinessStyles.ImgInput}>
                        <input
                            ref={inputRef}
                            className={BusinessStyles.ImgInput_input}
                            type="file"
                            onChange={handleFileChange}
                        />
                        {!source && <button type='button' onClick={handleChoose}>Choose</button>}
                        {source && (
                            <img
                                className={BusinessStyles.ImgInput_img}
                                width="100%"
                                src={source}
                                alt='uploadedimage'
                            />
                        )}
                            </div>
                        <div className={BusinessStyles.ImgInput_footer}>
                            {imageSelect ?
                                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                    {fileName}
                                    <DeleteForeverOutlinedIcon onClick={discardImage} sx={{ cursor: 'pointer' }} />
                                </div> :
                                ''}
                        </div>
                    <Button variant='contained' type='submit' className={BusinessStyles.saveChanges}>Save changes</Button>
                </form>
            </div>
        </div>
    )
}

export default AddProduct